import { Collapse } from "@chakra-ui/react";
import { cloneElement, isValidElement, useRef } from "react";

/**
 * @typedef {object} Props
 * @property {boolean} in
 * @property {boolean} [initial]
 *
 * @param {import("react").PropsWithChildren<Props>} props
 */
function CollapseAnimation({ in: _in, initial, children }) {
  const contentRef = useRef(
    isValidElement(children) ? cloneElement(children) : null,
  );

  if (_in) {
    contentRef.current = isValidElement(children)
      ? cloneElement(children)
      : null;
  }

  return (
    <Collapse in={_in} initial={initial}>
      {contentRef.current}
    </Collapse>
  );
}

export default CollapseAnimation;
